import { Type } from 'typebox';
export const MultipartUploadStatuses = {
    complete: 'complete',
    incomplete: 'incomplete',
    processed: 'processed'
};
export const MultipartUploadStatus = Type.Union([
    Type.Literal(MultipartUploadStatuses.incomplete),
    Type.Literal(MultipartUploadStatuses.complete),
    Type.Literal(MultipartUploadStatuses.processed)
]);
export const MultipartStatusPayload = Type.Object({
    uploadStatus: MultipartUploadStatus,
    response: Type.Optional(Type.Unknown())
});
export class HttpMultipartResource {
    #httpClient;
    constructor(httpClient) {
        this.#httpClient = httpClient;
    }
    async getStatus(id, options) {
        return await this.#httpClient.get({
            path: '/attachments/upload/status',
            queryParams: {
                id
            },
            payloadSchema: MultipartStatusPayload,
            signal: options?.signal
        });
    }
}
